import { intersect, struct } from 'io-ts/Decoder';

import { constants } from '@bedc/constants';

import { Id as OrganizationId } from '../../../../organization/Id';
import { Request as BaseRequest } from '../../../generic/search/Request';

export const Request = intersect(
	BaseRequest({
		sortFields: constants.wholeHouse.materialCategory.sortFields,
		columnFields: constants.wholeHouse.materialCategory.columnFields,
		standardFilterFields: constants.wholeHouse.materialCategory.osStandardFilterFields,
		dateFilterFields: constants.wholeHouse.materialCategory.osDateFilterFields,
		stageStatusFilterFields: [] as const,
		booleanFilterFields: [] as const,
	})
)(
	// support this structure similar to additional parameters
	struct({
		organizationId: OrganizationId,
	})
);
